export default __webpack_public_path__ + "static/media/raiffeisen_xl1.d88e1da2.png";